import IconArrowDown from '@/shared/icons/NewDesign/IconArrowDown'
import IconArrowUp from '@/shared/icons/NewDesign/IconArrowUp'
import IconSort from '@/shared/icons/NewDesign/IconSort'

interface SortIconProps {
  direction: 'ASC' | 'DESC' | null
}

const SortIcon = ({ direction }: SortIconProps) => {
  if (direction === 'ASC') return <IconArrowUp size={14} />
  if (direction === 'DESC') return <IconArrowDown size={14} />
  return <IconSort size={14} />
}

export default SortIcon
